import "./css/app.scss";

import "./js/assets/slider.js";

import popups from "./js/assets/popups";
import mobMenu from "./js/assets/mobMenu";
import readMore from "./js/assets/readmore";
import gridChange from "./js/assets/grid";
import descMenu from "./js/assets/descMenu";
import categoryTabs from "./js/assets/categoryTabs";
import search from "./js/assets/search";
// // import subscribe from './js/assets/subscribe';
// import accordian from './js/assets/accordian';
import stickyHeader from "./js/assets/stickyHeader";
// import formjs from './js/assets/form';
import headerHoverPopups from "./js/assets/headerHoverPopup.js";

popups.init();
mobMenu.init();
readMore.init();
categoryTabs.init();
gridChange.init();
search.init();
stickyHeader.init();
descMenu.init();
countDown.init();
headerHoverPopups.init();

import "./js/assets/neto.js";
import countDown from "./js/assets/countDown.js";
